module.exports = __webpack_public_path__ + "static/media/sparkling-fill.b983b1d3.svg";